import PhoneNumberPicker from "../../../../DomUtilities/PhoneNumberPicker";
import Mediator from "../../../../Utilities/Mediator";
import { isValidEmail } from "../../../../Validations/Validations";
import OrderHandler from "../../OrderHandler";

export default class AddNewCustomer {
	nameInput: HTMLInputElement
	phoneInput: HTMLInputElement;
	emailInput: HTMLInputElement;
	phonePicker: PhoneNumberPicker;
	nameError: HTMLParagraphElement;
	phoneError: HTMLParagraphElement;
	emailError: HTMLParagraphElement;

	constructor(inputsDiv: HTMLDivElement) {
		this.nameInput = inputsDiv.querySelector("input[name='name']");
		this.phoneInput = inputsDiv.querySelector("#phone");
		this.emailInput = inputsDiv.querySelector("input[name='email']");
		this.nameError = inputsDiv.querySelector("input[name='name'] + p");
		this.phoneError = inputsDiv.querySelector("p#phone-error");
		this.emailError = inputsDiv.querySelector("input[name='email'] + p");
		OrderHandler.order.customerPhoneNumber = null;
		OrderHandler.order.customerName = null;
		OrderHandler.order.customerEmail = null;

		this.init();
	}

	private init() {
		this.phonePicker = new PhoneNumberPicker(this.phoneInput);

		this.phonePicker.onUtilsLoad(() => {
			this.validateName();
			this.validatePhone();
			if (OrderHandler.isDibsEnabled) {
				this.validateEmail();
			}
		});

		this.addCustomerInputsValidationInputListener();
		Mediator.on("customerSelected", () => {
			this.validateName();
			this.validatePhone();
		});
	}

	public validateName() {
		if (this.nameInput.value.trim()) {
			this.nameError.style.opacity = "0";
			this.nameInput.style.borderColor = "#bdbdbd";
			OrderHandler.order.customerName = this.nameInput.value.trim();
		} else {
			this.nameError.style.opacity = "1";
			this.nameInput.style.borderColor = "red";
			OrderHandler.order.customerName = null;
		}

		Mediator.emit("orderStateChanged");
	}

	public validatePhone() {
		if (this.phonePicker.isValidPhoneNumber()) {
			this.phoneError.style.opacity = "0";
			this.phoneInput.style.borderColor = "#bdbdbd";
			OrderHandler.order.customerPhoneNumber = this.phonePicker.phoneNumber;
			this.phonePicker.phoneNumber = this.phoneInput.value;
		} else {
			this.phoneError.style.opacity = "1";
			this.phoneInput.style.borderColor = "red";
			OrderHandler.order.customerPhoneNumber = null;
		}

		Mediator.emit("orderStateChanged");
	}

	private validateEmail() {
		const emailValue: string = this.emailInput.value.trim();
		if (isValidEmail(emailValue)) {
			this.emailError.style.opacity = "0";
			this.emailInput.style.borderColor = "#bdbdbd";
			OrderHandler.order.customerEmail = emailValue;
		} else if (!emailValue && !OrderHandler.isDibsEnabled) {
			this.emailError.style.opacity = "0";
			this.emailInput.style.borderColor = "#bdbdbd";
			OrderHandler.order.customerEmail = null;
		} else {
			this.emailError.style.opacity = "1";
			this.emailInput.style.borderColor = "red";
			OrderHandler.order.customerEmail = null;
		}

		Mediator.emit("orderStateChanged");
	}

	private addCustomerInputsValidationInputListener() {
		this.phoneInput.oninput = () => {
			this.validatePhone();
		}

		this.nameInput.oninput = () => {
			this.validateName();
		}

		this.emailInput.oninput = () => {
			this.validateEmail();
		}

		this.phoneInput.addEventListener("countrychange", () => {
			this.validatePhone();
		});
	}
}
